import { takeEvery } from 'redux-saga/effects';
import { handleServerError } from '../actions';
import handleServerErrorWorker from './worker.handleServerError';

function* alertsSaga() {
  yield takeEvery(handleServerError, handleServerErrorWorker);
}

export default alertsSaga;
